import React, { Component } from 'react';
import { Form, message } from 'antd';
import { config, postFrom } from '../../../../../../axios';
import { dicPayChannel, dicPayType, liuShuiMeiJu } from '../../../../../../axios/dictionaries';
import { moneyAddComma } from '../../../../../../utils/index';
import moment from 'moment'
import "../index.less";
import Detail from '../../../../../Payment/components/Detailed/Detail';
import TableDOM from '../../../../../../components/Table';

class ReceiveWater extends Component {
    constructor(props) {
        super(props)
        this.state = {
            InputWidth: "185px",
            shortInputWidth: "135px",
            data: [],
            showDetailModal: false,
            current: 1, //当前页
            tableLoading: false,
            tableTotal: 0,
        }
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //receiveOrPay 1 收款账单  /  receiveOrPay 2 退款账单
        this.setState({ tableLoading: true });
        postFrom({
            url: config.API_rentcontract_getRentContractByIdTradeRecordMsg,
            data: {
                rentContractId: this.props.id,
                ...values
            }
        }).then(res => {
            this.setState({ data: res.records, tableTotal: res.total, current: res.current, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取信息失败');
            this.setState({ loading: false });
        });
    }

    handleShowDetail = (id) => { //显示详情
        this.setState({ showDetailModal: true });
        this.detailRef.loadPackage(id);
    }

    render() {
        let {
            data,
            showDetailModal,
            tableLoading,
            tableTotal,
            current,
        } = this.state;

        return (
            <div>
                <div className="custom" style={{ paddingBottom: "20px" }}>
                    <div className="flex-static bill-btn-box">
                        <div className="tab_active" style={{ cursor: "pointer" }}>收款流水</div>
                    </div>
                    <TableDOM
                        columns={columns({ handleShowDetail: this.handleShowDetail })}
                        data={data}
                        loading={tableLoading}
                        total={tableTotal}
                        current={current}
                        onChange={this.handleSearch}
                    />
                </div>
                <Detail
                    onRef={ref => this.detailRef = ref}
                    visible={showDetailModal}
                    handleCancel={() => { this.setState({ showDetailModal: false }) }}
                />
            </div>

        )
    }
}

const columns = ({ handleShowDetail }) => [
    {
        title: '交易时间',
        dataIndex: 'tradeTime',
        render(text) {
            return <span>
                <div>{text ? moment(text).format("YYYY-MM-DD") : null}</div>
                <div>{text ? moment(text).format("HH:mm:ss") : null}</div>
            </span>
        }
    },
    {
        title: '我方流水 | 他方流水',
        dataIndex: 'orderNo',
        render(text, record) {
            return <span>
                <div>{text}</div>
                <div>{record.orderNoThird}</div>
            </span>
        }
    },
    {
        title: '交易金额 | 名称',
        dataIndex: 'amount',
        render(text, record) {
            return <span>
                <div>{moneyAddComma(text)}</div>
                <div>{record.feeName}</div>
            </span>
        }
    },
    {
        title: '交易渠道 | 方式',
        dataIndex: 'payChannel',
        render(text, record) {
            let d = dicPayChannel.find(item => item.value === text);
            let p = dicPayType.find(item => item.value === record.payType);
            return <span>
                <div>{d ? d.title : ''}</div>
                <div>{p ? p.title : ''}</div>
            </span>
        }
    },
    {
        title: '租客',
        dataIndex: 'customerName',
        render(text, record) {
            return <span>
                <div>{text}</div>
                <div>{record.customerPhone}</div>
            </span>
        }
    },
    {
        title: '交易状态',
        dataIndex: 'status',
        render(text) {
            let b = liuShuiMeiJu.find(item => item.value === text);
            return <span>{b ? b.title : ''}</span>
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        render(text, record, index) {
            return (
                <div className="table-action">
                    <span className="showClickDetail" onClick={() => { handleShowDetail(record.id) }} >详情</span>
                </div>
            )
        }
    }
];

export default Form.create()(ReceiveWater)


// WEBPACK FOOTER //
// ./src/page/RentContract/components/List/details/ReceiveWater/index.js